import { render } from "./DashProfileHelp.vue?vue&type=template&id=1b1df038"
import script from "./DashProfileHelp.vue?vue&type=script&lang=js"
export * from "./DashProfileHelp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__